import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/documents';

const namespace = 'DOCUMENT';

export const FETCH_CODEFILE_DOCUMENT_STATUS_START = `${namespace}/ FETCH_CODEFILE_DOCUMENT_STATUS_START`;
export const FETCH_CODEFILE_DOCUMENT_STATUS_SUCCESS = `${namespace}/FETCH_CODEFILE_DOCUMENT_STATUS_SUCCESS`;
export const FETCH_CODEFILE_DOCUMENT_STATUS_ERROR = `${namespace}/FETCH_CODEFILE_DOCUMENT_STATUS_ERROR`;

export const fetchCodefileDocumentStatus = makeApiActionCreatorV3(
  api.fetchCodefileDocumentStatus,
  FETCH_CODEFILE_DOCUMENT_STATUS_START,
  FETCH_CODEFILE_DOCUMENT_STATUS_SUCCESS,
  FETCH_CODEFILE_DOCUMENT_STATUS_ERROR,
);

export const FETCH_DOCUMENTS_START = `${namespace}/FETCH_DOCUMENTS_START`;
export const FETCH_DOCUMENTS_SUCCESS = `${namespace}/FETCH_DOCUMENTS_SUCCESS`;
export const FETCH_DOCUMENTS_ERROR = `${namespace}/FETCH_DOCUMENTS_ERROR`;

export const fetchDocuments = makeApiActionCreatorV3(
  api.fetchDocuments,
  FETCH_DOCUMENTS_START,
  FETCH_DOCUMENTS_SUCCESS,
  FETCH_DOCUMENTS_ERROR,
);

export const FETCH_DOCUMENT_START = `${namespace}/FETCH_DOCUMENT_START`;
export const FETCH_DOCUMENT_SUCCESS = `${namespace}/FETCH_DOCUMENT_SUCCESS`;
export const FETCH_DOCUMENT_ERROR = `${namespace}/FETCH_DOCUMENT_ERROR`;

export const fetchDocument = makeApiActionCreatorV3(
  api.fetchDocument,
  FETCH_DOCUMENT_START,
  FETCH_DOCUMENT_SUCCESS,
  FETCH_DOCUMENT_ERROR,
);

export const FETCH_DOCUMENT_FILES_START = `${namespace}/FETCH_DOCUMENT_FILES_START`;
export const FETCH_DOCUMENT_FILES_SUCCESS = `${namespace}/FETCH_DOCUMENT_FILES_SUCCESS`;
export const FETCH_DOCUMENT_FILES_ERROR = `${namespace}/FETCH_DOCUMENT_FILES_ERROR`;

export const fetchDocumentFiles = makeApiActionCreatorV3(
  api.fetchDocumentFiles,
  FETCH_DOCUMENT_FILES_START,
  FETCH_DOCUMENT_FILES_SUCCESS,
  FETCH_DOCUMENT_FILES_ERROR,
);

export const FETCH_DOCUMENT_FILE_START = `${namespace}/FETCH_DOCUMENT_FILE_START`;
export const FETCH_DOCUMENT_FILE_SUCCESS = `${namespace}/FETCH_DOCUMENT_FILE_SUCCESS`;
export const FETCH_DOCUMENT_FILE_ERROR = `${namespace}/FETCH_DOCUMENT_FILE_ERROR`;

export const fetchDocumentFile = makeApiActionCreatorV3(
  api.fetchDocumentFile,
  FETCH_DOCUMENT_FILE_START,
  FETCH_DOCUMENT_FILE_SUCCESS,
  FETCH_DOCUMENT_FILE_ERROR,
);

export const INSERT_DOCUMENT_START = `${namespace}/INSERT_DOCUMENT_START`;
export const INSERT_DOCUMENT_SUCCESS = `${namespace}/INSERT_DOCUMENT_SUCCESS`;
export const INSERT_DOCUMENT_ERROR = `${namespace}/INSERT_DOCUMENT_ERROR`;

export const insertDocument = makeApiActionCreatorV3(
  api.insertDocument,
  INSERT_DOCUMENT_START,
  INSERT_DOCUMENT_SUCCESS,
  INSERT_DOCUMENT_ERROR,
);

export const INSERT_DOCUMENT_FILE_START = `${namespace}/INSERT_DOCUMENT_FILE_START`;
export const INSERT_DOCUMENT_FILE_SUCCESS = `${namespace}/INSERT_DOCUMENT_FILE_SUCCESS`;
export const INSERT_DOCUMENT_FILE_ERROR = `${namespace}/INSERT_DOCUMENT_FILE_ERROR`;

export const insertDocumentFile = makeApiActionCreatorV3(
  api.insertDocumentFile,
  INSERT_DOCUMENT_FILE_START,
  INSERT_DOCUMENT_FILE_SUCCESS,
  INSERT_DOCUMENT_FILE_ERROR,
);

export const UPDATE_DOCUMENT_START = `${namespace}/UPDATE_DOCUMENT_START`;
export const UPDATE_DOCUMENT_SUCCESS = `${namespace}/UPDATE_DOCUMENT_SUCCESS`;
export const UPDATE_DOCUMENT_ERROR = `${namespace}/UPDATE_DOCUMENT_ERROR`;

export const updateDocument = makeApiActionCreatorV3(
  api.updateDocument,
  UPDATE_DOCUMENT_START,
  UPDATE_DOCUMENT_SUCCESS,
  UPDATE_DOCUMENT_ERROR,
);

export const UPDATE_DOCUMENT_TAGS_START = `${namespace}/UPDATE_DOCUMENT_TAGS_START`;
export const UPDATE_DOCUMENT_TAGS_SUCCESS = `${namespace}/UPDATE_DOCUMENT_TAGS_SUCCESS`;
export const UPDATE_DOCUMENT_TAGS_ERROR = `${namespace}/UPDATE_DOCUMENT_TAGS_ERROR`;

export const updateDocumentTags = makeApiActionCreatorV3(
  api.updateDocumentTags,
  UPDATE_DOCUMENT_TAGS_START,
  UPDATE_DOCUMENT_TAGS_SUCCESS,
  UPDATE_DOCUMENT_TAGS_ERROR,
);

export const DELETE_DOCUMENT_START = `${namespace}/DELETE_DOCUMENT_START`;
export const DELETE_DOCUMENT_SUCCESS = `${namespace}/DELETE_DOCUMENT_SUCCESS`;
export const DELETE_DOCUMENT_ERROR = `${namespace}/DELETE_DOCUMENT_ERROR`;

export const deleteDocument = makeApiActionCreatorV3(
  api.deleteDocument,
  DELETE_DOCUMENT_START,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_ERROR,
);

export const DELETE_DOCUMENT_FILE_START = `${namespace}/DELETE_DOCUMENT_FILE_START`;
export const DELETE_DOCUMENT_FILE_SUCCESS = `${namespace}/DELETE_DOCUMENT_FILE_SUCCESS`;
export const DELETE_DOCUMENT_FILE_ERROR = `${namespace}/DELETE_DOCUMENT_FILE_ERROR`;

export const deleteDocumentFile = makeApiActionCreatorV3(
  api.deleteDocumentFile,
  DELETE_DOCUMENT_FILE_START,
  DELETE_DOCUMENT_FILE_SUCCESS,
  DELETE_DOCUMENT_FILE_ERROR,
);

export const DOWNLOAD_DOCUMENT_FILE_START = `${namespace}/DOWNLOAD_DOCUMENT_FILE_START`;
export const DOWNLOAD_DOCUMENT_FILE_SUCCESS = `${namespace}/DOWNLOAD_DOCUMENT_FILE_SUCCESS`;
export const DOWNLOAD_DOCUMENT_FILE_ERROR = `${namespace}/DOWNLOAD_DOCUMENT_FILE_ERROR`;

export const downloadDocumentFile = makeApiActionCreatorV3(
  api.downloadDocumentFile,
  DOWNLOAD_DOCUMENT_FILE_START,
  DOWNLOAD_DOCUMENT_FILE_SUCCESS,
  DOWNLOAD_DOCUMENT_FILE_ERROR,
);
